import { ColorTile } from "../ColorTile";
import { TILE_SIZE } from "../opts";
import { strictCompose } from "../compose";
var Turn;
(function (Turn) {
    Turn[Turn["RED"] = -1] = "RED";
    Turn[Turn["NONE"] = 0] = "NONE";
    Turn[Turn["BLACK"] = 1] = "BLACK";
})(Turn || (Turn = {}));
function turnColor(turn) {
    return turn === Turn.RED ? "RED" : turn === Turn.BLACK ? "black" : "grey";
}
class TickTackToeGame {
    constructor() {
        this.turn = Turn.RED;
        this.won = Turn.NONE;
        this.blankTiles = 0;
    }
}
const MARGIN = TILE_SIZE / 6;
function singleStepMovement(dir) {
    return (t) => {
        if (!t)
            return null;
        return t.getNeighbor(dir);
    };
}
function movement(dirs) {
    return strictCompose(dirs.map(singleStepMovement));
}
const movementMethods = [
    [3 /* top */, 1 /* bottom */].map(singleStepMovement),
    [2 /* left */, 0 /* right */].map(singleStepMovement),
    [
        [2 /* left */, 1 /* bottom */],
        [3 /* top */, 0 /* right */]
    ].map(movement),
    [
        [1 /* bottom */, 2 /* left */],
        [0 /* right */, 3 /* top */]
    ].map(movement),
    [
        [2 /* left */, 3 /* top */],
        [1 /* bottom */, 0 /* right */]
    ].map(movement),
    [
        [3 /* top */, 2 /* left */],
        [0 /* right */, 1 /* bottom */]
    ].map(movement)
];
export class TickTackToeTile extends ColorTile {
    constructor(lengthForWin = 3) {
        super("white");
        this.occupied = Turn.NONE;
        this.game = null;
        this.isWinningLine = false;
        this.lengthForWin = lengthForWin;
    }
    render(ctx, t, playerDist, playerShear) {
        super.render(ctx, t, playerDist, playerShear);
        ctx.fillStyle = turnColor(this.occupied);
        const margin = this.game && ((this.game.won !== Turn.NONE || this.game.blankTiles === 0) && !this.isWinningLine) ? MARGIN * 2 : MARGIN;
        ctx.fillRect(margin, margin, TILE_SIZE - margin * 2, TILE_SIZE - margin * 2);
        if (this.game && t - this.stepTime < 100) {
            ctx.strokeStyle = turnColor(this.game.turn);
            ctx.lineWidth = 5;
            ctx.strokeRect(margin, margin, TILE_SIZE - margin * 2, TILE_SIZE - margin * 2);
        }
    }
    tallyInDir(movmentPattern) {
        let view = this.getView(0);
        for (let i = 0; i < this.lengthForWin; i++) {
            view = movmentPattern(view);
            if (!view || !(view.tile instanceof TickTackToeTile && view.tile.occupied === this.occupied)) {
                return i;
            }
        }
        return this.lengthForWin;
    }
    drawWinningLine(movmentPattern) {
        let view = this.getView(0);
        for (let i = 0; i < this.lengthForWin; i++) {
            view = movmentPattern(view);
            if (!view || !(view.tile instanceof TickTackToeTile && view.tile.occupied === this.occupied)) {
                return;
            }
            view.tile.isWinningLine = true;
        }
    }
    didWin() {
        for (let pair of movementMethods) {
            const n = this.tallyInDir(pair[0]) + this.tallyInDir(pair[1]) + 1;
            if (n >= this.lengthForWin) {
                this.drawWinningLine(pair[0]);
                this.drawWinningLine(pair[1]);
                this.isWinningLine = true;
                return true;
            }
        }
        return false;
    }
    linkGame(game = new TickTackToeGame()) {
        if (this.game !== game) {
            this.occupied = Turn.NONE;
            this.isWinningLine = false;
            this.game = game;
            game.blankTiles++;
            this.links.forEach((link) => {
                if (!link)
                    return;
                const tile = link.to;
                if (tile instanceof TickTackToeTile) {
                    tile.linkGame(game);
                }
            });
        }
    }
    stepOn(t) {
        super.stepOn(t);
        if (this.game === null) {
            this.linkGame();
        }
    }
    interact() {
        if (this.game === null || this.game.won !== Turn.NONE || this.game.blankTiles === 0) {
            this.linkGame();
            return;
        }
        if (this.occupied === Turn.NONE) {
            this.occupied = this.game.turn;
            this.game.turn = -this.game.turn;
            this.game.blankTiles--;
            if (this.didWin()) {
                this.game.won = this.occupied;
            }
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/tickTackToe/TickTackToeTile.ts
// module id = 17
// module chunks = 0